import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useFetchById from 'hooks/useFetchById';

import UserViewMode from 'components/admin/user/UserDetail/UserViewMode';
import UserEditForm from 'components/admin/user/UserDetail/UserEditForm';

import { adminUserApi } from 'api';

const UserDetail = () => {
  const { userId } = useParams();
  const [isEditing, setIsEditing] = useState(false);

  const {
    data: user,
    loading: fetchLoading,
    error: fetchError,
    refetch,
  } = useFetchById(adminUserApi, userId);

  const handleEditClick = () => {
    if (user) {
      setIsEditing(true);
    }
  };

  const handleEditSuccess = async () => {
    await refetch();
    setIsEditing(false);
  };

  if (fetchLoading) {
    return (
      <Card className="h-100">
        <Card.Body>
          <div className="text-center">Loading...</div>
        </Card.Body>
      </Card>
    );
  }

  if (fetchError) {
    return (
      <Card className="h-100">
        <Card.Body>
          <Alert variant="danger">{fetchError}</Alert>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Header className="bg-light">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">User Detail</h5>

          {!isEditing && (
            <Button variant="primary" size="sm" onClick={handleEditClick}>
              <FontAwesomeIcon icon="edit" className="me-2" />
              Edit
            </Button>
          )}
        </div>
      </Card.Header>

      <Card.Body>
        {isEditing ? (
          <UserEditForm
            user={user}
            onSuccess={handleEditSuccess}
            onCancel={() => setIsEditing(false)}
          />
        ) : (
          <UserViewMode user={user} />
        )}
      </Card.Body>
    </Card>
  );
};

export default UserDetail;
